import React from 'react';
import styled from 'styled-components';
import AuthTitle from './AuthTitle';
import AuthLayoutFrame from './AuthLayoutFrame';
import errorIcon from './error.png';
import { Skeleton } from 'primereact/skeleton';

type Props = {
  imageType?: 'error';
  imageSrc?: string;
  imageAlt?: string;
  imageSkeleton?: boolean;
  title: string;
  message?: string | null;
  link?: React.ReactNode;
};

const AuthStatusPage: React.FC<Props> = ({ imageType, imageSrc, imageAlt, imageSkeleton, title, message, link }) => {
  return (
    <AuthLayoutFrame>
      <Content>
        {imageSkeleton ? (
          <Skeleton width="176px" height="176px" />
        ) : (
          <Image src={imageType === 'error' ? errorIcon : imageSrc} alt={imageAlt} />
        )}
        <AuthTitle>{title}</AuthTitle>
        {message && <Message>{message}</Message>}
        {link}
      </Content>
    </AuthLayoutFrame>
  );
};

export default AuthStatusPage;

const Content = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  text-align: center;
  padding: 16px;
`;

const Image = styled.img`
  width: 176px;
  height: 176px;
`;

const Message = styled.div`
  font-size: 16px;
  line-height: 24px;
  max-width: 660px;
  white-space: pre-wrap;
`;
